import isMobile from 'ismobilejs';

const showBase64quote = (base64: string): void => {
    const byteString = window.atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }

    const blobUrl = URL.createObjectURL(new Blob([arrayBuffer], { type: 'application/pdf' }));
    const devices = isMobile(window.navigator);
    const isDevicePhoneOrTablet = devices.phone || devices.tablet;

    if (isDevicePhoneOrTablet) {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', 'quote.pdf');
        link.setAttribute('href', blobUrl);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        window.open(blobUrl, '_blank')?.focus();
    }

    URL.revokeObjectURL(blobUrl);
};

export { showBase64quote };
